export default "<full-calendar [options]=\"calendarOptions\"></full-calendar>";